import codes from '@/codes';

//restufl api
import { detect as wsfinder } from '@/service/api/wsfinder'

export default {
  data : () => {
    return { model : {}, codes }
  },
  methods: {
    list() { this.$router.push({ name: 'wsfinder_detect'}); },
    async get({ id } = this.$route.params) {
      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      try {
        let rs = await wsfinder.detailDetect({id : id});
        this.model = Object.assign({ group: {} }, this.model, rs.body)
        this.model.description = JSON.parse(rs.body.description);
        console.log("description : ", this.model.description)
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) , this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('detect.detail.vue', 'created'); },
  destroyed: function() { console.log('detect.detail.vue', 'destroyed'); },
  mounted: function() { console.log('detect.detail.vue', 'mounted'); this.get(this.$route.params); },
}